import axios from "axios";
const AUTH = "Bearer 3b0ec705-120d-4918-8319-75f196991477";

export const startRecording = async (
  url: string,
  uid: string,
  channel: string,
  eventid: string
) => {
  const response = await axios.post(
    `${url}/recored/start`,
    {
      uid: uid,
      channel: channel,
      eventId: eventid,
      eventid: eventid,
    },
    {
      headers: {
        Authorization: AUTH,
      },
    }
  );
  return response;
};
export const endRecording = async (
  url: string,
  channel: string,
  eventid: string
) => {
  const response = await axios.post(
    `${url}/recored/stop`,
    {
      channel: channel,
      eventId: eventid,
      eventid: eventid,
    },
    {
      headers: {
        Authorization: AUTH,
      },
    }
  );
  return response;
};
